import React, { useEffect, useRef, useState } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import classNames from 'classnames/bind';
import styles from './index.module.scss';
import { Phone } from '../../components/helpers/PhoneNumber';
import dynamic from 'next/dynamic';
import ReCAPTCHA from 'react-google-recaptcha';

const NEXT_PUBLIC_RECAPTCHA_SITE_KEY = '6Le-UtseAAAAAGpB4ucUJNIvZslgvZXc77lRT3tG';

const Modal = dynamic(() => import('../../components/_bloks/Modal/Modal'));
import axios from 'axios';
import { ChevronRightIcon } from '@heroicons/react/solid';

const cx = classNames.bind(styles);
const ContactUs = props => {
  const [loaded, setLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [comment, setComment] = useState('');
  const [job, setJob] = useState('default');
  const [industry, setIndustry] = useState('default');
  const [country, setCountry] = useState(props.country);
  const [continent, setContinent] = useState(props.continent);
  const [sectionClasses, setSectionClasses] = useState(null);
  const [sectionClassesReverse, setSectionClassesReverse] = useState(null);
  useEffect(() => {
    if (props.country !== country) {
      setCountry(props.country);
    }
    if (props.continent !== continent) {
      setContinent(props.continent);
    }
  }, [props.country, props.continent]);
  useEffect(() => {
    const handleResize = () => {
      setSectionClasses(
        cx({
          'bg-gray-lightorGray': window.innerWidth > 1000,
          'bg-white': window.innerWidth <= 1000,
          Montserrat: true,
        })
      );
      setSectionClassesReverse(
        cx({
          'bg-gray-light': window.innerWidth < 1000,
          'bg-white': window.innerWidth >= 1000,
          Montserrat: true,
        })
      );
    };
    // window.addEventListener('resize', handleResize)
    handleResize();
  });
  const jobs = [
    'CEO/C-Level / VP',
    'Marketing Manager / Marketing Director',
    'Operations Manager',
    'Financial Manager',
    'Production Manager',
    'Other',
  ];
  const industries = [
    'Operations Manager',
    'Accounting and Finance',
    'Construction',
    'Creative and Design',
    'Customer Service',
    'Education',
    'Energy and Utilities',
    'Engineering',
    'Financial Services',
    'Healthcare',
    'IT',
    'Legal',
    'Marketing and Advertising',
    'Other',
  ];
  const reRef = useRef();

  async function handleSubmit(e) {
    e.preventDefault();
    const token = reRef.current.getValue();
    reRef.current.reset();
    if (token) {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('email', email);
      formData.append('phone', phone);
      formData.append('comments', comment);
      formData.append('job', job);
      formData.append('industry', industry);
      formData.append('country', country);
      formData.append('token', token);
      // setShowModal(true)
      axios.post('https://mailer.weprodigi.com/api/v1/contact-us', formData).then(response => {
        window.location.href = 'https://weprodigi.com/thank-you';
        // setLoaded(true);
        // setName('')
        // setEmail('')
        // setPhone('')
        // setComment('')
        // setJob('default')
        // setIndustry('default')
        // setCountry('')
      });
    }
  }

  const hideModal = () => {
    setShowModal(false);
  };
  const getPhone = () => {
    if (continent == 'Europe') {
      return '+442045770272';
    }
    switch (country) {
      case 'AU':
        return '+61288800313';
      case 'CA':
        return '+14378860987';
      case 'NZ':
        return '+6448881388';
      case 'SG':
        return '+6531594885';
      case 'GB':
        return '+442045770272';
      case 'US':
        return '+19295909255';
      case 'AM':
        return '+37444224226';
      default:
        return '+19295909255';
    }
  };
  return (
    <>
      <Head>
        <title>Contact Us | Request a quote | Prodigi Marketing Agency</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/contact-us" />
        <meta
          name="description"
          content="Do you have questions about our digital services? Contact us, and our experts will be happy to answer any questions you may have."
        />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `
                {
                
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": "https://weprodigi.com#Organization",
        "address": "Anastas Mikoyan 2/2, Yerevan 0090, Armenia",
        "award": [],
        "description": "Prodigi is a digital marketing and production company specializing in PPC services, SMM, Web Development, Games, and Video production services.",
        "alternateName": "Prodigi",
        "email": "info@weprodigi.com",
        "foundingDate": "2017-09-28",
        "image": "https://weprodigi.com/uploads/images/home-page/our_services.jpg",
        "knowsLanguage": [
        "hy",
        "en",
        "ru",
        "fr"
    ],
        "legalName": "Prodigi LLC",
        "logo": "https://weprodigi.com/images/logovertical.svg",
        "name": "Prodigi Marketing Agency",
        "sameAs": [
        "https://www.facebook.com/weprodigi/",
        "https://www.instagram.com/prodigi.agency/",
        "https://www.linkedin.com/company/weprodigiagency/",
        "https://www.youtube.com/@prodigi.agency",
        "https://x.com/weprodigiagency",
        "https://goo.gl/maps/rfbWAUxxzA2Kb4am8"
    ],
        "slogan": "Digital Marketing Agency That Brings Results",
        "telephone": [
        "+37444224226",
        "+37444755855",
        "+14378860987",
        "+442045770272",
        "+61288800313",
        "+19295909255"
    ],
        "url": "https://weprodigi.com/",
        "knowsAbout": [
        "https://en.wikipedia.org/wiki/Web_design",
        "https://en.wikipedia.org/wiki/Digital_marketing",
        "https://en.wikipedia.org/wiki/Graphic_design",
        "https://en.wikipedia.org/wiki/Video_clip#Advertising",
        "https://en.wikipedia.org/wiki/Social_media_marketing",
        "https://en.wikipedia.org/wiki/Search_engine_optimization",
        "https://en.wikipedia.org/wiki/Online_advertising"
    ],
        "taxID": "01278077",
        "founder": [
        {
            "@id": "https://weprodigi.com#BorisSahakyan"
        },
        {
            "@id": "https://weprodigi.com#AidaVopyan"
        },
        {
            "@id": "https://weprodigi.com#ArsenSultanyan"
        }
    ],
        "numberOfEmployees": {
        "@id": "https://weprodigi.com#NumberOfEmployees"
    },
        "aggregateRating": {
        "@id": "https://weprodigi.com#AggRating"
    }
    }
        `,
          }}
        />

        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `
               {"@context": "https://schema.org",
        "@type": "Person",
        "@id": "https://weprodigi.com#BorisSahakyan",
        "colleague": "https://en.wikipedia.org/wiki/Yerevan_State_University",
        "gender": "male",
        "image": "https://weprodigi.com/images/team/boris2.png",
        "jobTitle": "Co-founder",
        "knowsLanguage": [
        "hy",
        "en",
        "ru"
    ],
        "name": "Boris Sahakyan",
        "sameAs": [
        "https://www.linkedin.com/in/boris-sahakyan-3243364b/",
        "https://www.facebook.com/BorisSahakyan"
    ]
    }
        `,
          }}
        />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `
               {
        "@context": "https://schema.org",
        "@type": "Person",
        "@id": "https://weprodigi.com#ArsenSultanyan",
        "gender": "male",
        "image": "https://weprodigi.com/images/team/arsen2.png",
        "birthDate": "1981-12-05",
        "colleague": "https://en.wikipedia.org/wiki/Armenian_State_University_of_Economics",
        "jobTitle": "Co-founder",
        "knowsLanguage": [
        "hy",
        "en",
        "ru"
    ],
        "name": "Arsen Sultanyan",
        "sameAs": [
        "https://www.facebook.com/arsen.sultanyan",
        "https://www.linkedin.com/in/arsensultanyan/"
    ]
    }
        `,
          }}
        />

        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `
               {
        "@context": "https://schema.org",
        "@type": "AggregateRating",
        "@id": "https://weprodigi.com#AggRating",
        "bestRating": "5",
        "ratingCount": "23",
        "ratingValue": "5",
        "url": "https://goo.gl/maps/rfbWAUxxzA2Kb4am8",
        "worstRating": "1",
        "name": "Google Map AggRating"
    }
        `,
          }}
        />
      </Head>

      <div className={sectionClassesReverse}>
        <div className="container pb-50">
          <h1 className={`md:text-48 sm:text-40 xl:leading-59 text-title uppercase font-black md:pt-50 sm:pt-20`}>Contact Us</h1>

          <div className={'flex  flex-wrap pt-5'}>
            <div className={`w-full md:w-2/3   uppercase xl:leading-59 `}>
              <div className="flex pb-35 sm:flex md:block lg:block xl:block">
                <div className="image-container max-w-300 sm:max-w-300 md:max-w-400 lg:max-w-503 xl:max-w-503">
                  <Image
                    src={'/images/contacts/sales.jpg'}
                    width={500}
                    height={500}
                    alt="Anna Tshartaryan"
                    layout="intrinsic"
                    className="z-0 w-auto min-w-0 min-h-0 m-0 max-w-503"
                  />
                </div>
                <div>
                  <p
                    className={`break-words z-4 relative mt-600 xl:-mt-81 text-20 sm:text-25 md:text-35 lg:text-40 xl:text-48 text-green pl-10 xl:w-440 md:w-auto font-black`}
                  >
                    Anna Tshartaryan
                  </p>
                  <p className="w-auto ml-10 font-thin normal-case text-18 sm:text-18 md:text-16 lg:text-18 xl:text-18 leading-22p sm:w-auto md:w-80p lg:w-80p xl-w-80p text-gray-dark">
                    We are all ears for your needs to create game-changing projects together.
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/3">
              <div>
                <form onSubmit={handleSubmit} id="form">
                  <div className={`rounded-5 bg-gray p-20 max-w-384`}>
                    <div className="relative">
                      <label htmlFor="contact-us-name" className={`font-normal text-14   block text-gray-700 text-sm  mb-2`}>
                        Your Name*
                      </label>
                      <input
                        name="name"
                        type="text"
                        placeholder=""
                        className={`text-15 appearance-none text-black-primary border h-35 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                        id="contact-us-name"
                        required
                        value={name}
                        onChange={e => setName(e.target.value)}
                      />
                    </div>
                    <div className="relative mt-15">
                      <label htmlFor="contact-us-email" className={` font-normal text-14   block text-gray-700 text-sm  mb-2`}>
                        Email*
                      </label>
                      <input
                        name="email"
                        type="email"
                        placeholder=""
                        className={`text-15 appearance-none  text-black-primary border h-35 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                        id="contact-us-email"
                        required
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="relative mt-15">
                      <label htmlFor="contact-us-phone" className={`font-normal text-14   block text-gray-700 text-sm  mb-2`}>
                        Phone Number
                      </label>
                      <input
                        name="phone"
                        type="text"
                        className={`text-15 appearance-none  text-black-primary border h-35 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                        id="contact-us-phone"
                        value={phone}
                        onChange={e => setPhone(e.target.value)}
                      />
                    </div>
                    <div className="relative mt-15">
                      <label htmlFor="job" className={`font-normal text-14   block text-gray-700 text-sm  mb-2`}>
                        Job Position
                      </label>
                      <ChevronRightIcon className="absolute w-20 h-20 text-purple right-5 top-30" width={20} height={20} />
                      <select
                        name="job"
                        className={`w-full text-15 text-title h-35 pl-3 pr-6  text-black-primary  text-base placeholder-gray-600 border rounded-lg appearance-none focus:outline-none focus:shadow-outline`}
                        id="job"
                        value={job}
                        onChange={e => setJob(e.target.value)}
                      >
                        <option value="default" disabled hidden>
                          Please Select
                        </option>
                        {Object.keys(jobs).map(i => {
                          return (
                            <option key={i} value={jobs[i]}>
                              {jobs[i]}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="relative mt-15">
                      <label htmlFor="industry" className={`font-normal text-14   block text-gray-700 text-sm  mb-2`}>
                        Industry
                      </label>
                      <ChevronRightIcon className="absolute w-20 h-20 text-purple right-5 top-30" />
                      <select
                        name="industry"
                        className={`w-full text-15 text-title h-35 pl-3 pr-6  text-black-primary  text-base placeholder-gray-600 border rounded-lg appearance-none focus:outline-none focus:shadow-outline`}
                        id="industry"
                        value={industry}
                        onChange={e => setIndustry(e.target.value)}
                      >
                        <option value="default" disabled hidden>
                          Please Select
                        </option>
                        {Object.keys(industries).map(i => {
                          return (
                            <option key={i} value={industries[i]}>
                              {industries[i]}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="relative mt-15">
                      <label htmlFor="comments" className={`font-normal text-14   block text-gray-700 text-sm  mb-2`}>
                        Comments
                      </label>
                      <textarea
                        name="comments"
                        className={`w-full h-167 px-3 py-2 text-15 text-title resize-none placeholder-gray-600 border rounded-lg focus:outline-none focus:shadow-outline`}
                        id="comments"
                        rows="6"
                        value={comment}
                        onChange={e => setComment(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="relative mt-15">
                      <label htmlFor="country"> </label>
                      <input type="hidden" name="country" value={country} id="country" />
                    </div>
                    <ReCAPTCHA sitekey={NEXT_PUBLIC_RECAPTCHA_SITE_KEY} size={'normal'} ref={reRef} />
                  </div>

                  <div>
                    <button
                      id="contact-us-button"
                      type="submit"
                      form="form"
                      className="w-full p-10 mt-10 font-normal text-center text-white text-18 rounded-5 bg-green "
                      aria-label="submit button"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Modal show={showModal} hide={hideModal} loaded={loaded} version="contact-us" />
      </div>

      <div className={sectionClasses} id="contact-information">
        <div className={`flex flex-wrap justify-between container mt-20 md:mt-25 pb-0 md:pb-40 pt-20 ${styles.infoPart}`}>
          <div className={`w-full md:w-half-auto text-left `}>
            <div>
              <p className="pb-0 uppercase text-purple font-bolder text-16 md:text-18 leading-20 md:pb-0">Legal Information in US</p>
              <p className="block mt-5 font-medium md:block lg:block xl:block leading-28 md:mt-10">
                <span className="font-medium text-16 md:text-18 leading-28">Company name: ProDigi</span>
              </p>
              <p className="block md:block text-16 md:text-18 lg:block xl:block leading-28 font-b300">
                <span className="font-medium text-16 md:text-18 leading-25">Legal name of the company: </span>Digital Caramel, Inc.
              </p>
              <p className="block md:block text-16 md:text-18 lg:block xl:block leading-28 font-b300">
                <span className="font-medium text-16 md:text-18 leading-25">Address: </span>10601 Clarence Drive, Suite 250
                <span className={'hidden md:inline'}>, Frisco, TX, 75033</span>
              </p>
              <p className="flex sm:flex md:block text-16 md:text-18 lg:block leading-28 font-b300">
                <span className="font-medium text-16 md:text-18 leading-25">Tax ID: </span>37-1996656
              </p>
            </div>
          </div>
          <div className={`w-full md:w-half-auto text-left `}>
            <div className={'mt-20 md:mt-0'}>
              <p className="pb-0 uppercase text-purple font-bolder text-16 md:text-18 leading-20 md:pb-0">Legal Information in Armenia</p>
              <p className="block mt-5 font-medium md:flex lg:block leading-28 md:mt-10">
                <span className="font-medium text-16 md:text-18 leading-28">Company name: Prodigi LLC</span>
              </p>
              <p className="block md:flex text-16 md:text-18 lg:block leading-28 font-b300">
                <span className="font-medium text-16 md:text-18 leading-25">Address: </span> 22 Vardanants,Yerevan 0070, Armenia
              </p>
              <p className="block md:flex text-16 md:text-18 lg:block leading-28 font-b300">
                <span className="font-medium text-16 md:text-18 leading-25">TIN </span> (Taxpayer Identification Number): 01278077
              </p>
              <p className="block md:flex text-16 md:text-18 lg:block leading-28 font-b300">
                <span className="font-medium text-16 md:text-18 leading-25">Government Register </span> Certificate Number: 271.110.975865
              </p>
            </div>
          </div>
          <div className={`w-full md:w-half-auto text-left mt-20 md:mt-32`}>
            <div className="">
              <p className="uppercase text-purple font-bolder text-16 md:text-18 leading-20 ">Call us from around the world</p>
              <p className="flex justify-between w-full mt-5 font-medium lg:w-80p xl:w-80p md:w-80p md:mt-10 md:justify-start text-16 md:text-18 leading-31">
                <a href={'tel:+14378860987'} className={'block font-b300'}>
                  +14378860987 - <span className={'font-medium'}>Canada</span>
                </a>
                <span className={`w-26 h-26 inline-block align-middle bg-center bg-no-repeat ml-10 ${styles.ca}`} />
              </p>
              <p className="flex justify-between w-full font-medium lg:w-80p xl:w-80p md:w-80p md:justify-start text-16 md:text-18 leading-31">
                <a href={'tel:+442045770272'} className={'block font-b300'}>
                  +442045770272 - <span className={'font-medium'}>UK</span>
                </a>
                <span className={`w-26 h-26 inline-block align-middle bg-center bg-no-repeat ml-10 ${styles.uk}`} />
              </p>
              <p className="flex justify-between w-full font-medium lg:w-80p xl:w-80p md:w-80p md:justify-start text-16 md:text-18 leading-31">
                <a href={'tel:+61288800313'} className={'block font-b300'}>
                  +61288800313 - <span className={'font-medium'}>Australia</span>
                </a>
                <span className={`w-26 h-26 inline-block align-middle bg-center bg-no-repeat ml-10 ${styles.au}`} />
              </p>
              <p className="flex justify-between w-full font-medium lg:w-80p xl:w-80p md:w-80p md:justify-start text-16 md:text-18 leading-31">
                <a href={'tel:+6448881388'} className={'block font-b300'}>
                  +6448881388 - <span className={'font-medium'}>New Zealand</span>
                </a>
                <span className={`w-26 h-26 inline-block align-middle bg-center bg-no-repeat ml-10 ${styles.nz}`} />
              </p>
              <p className="flex justify-between w-full font-medium lg:w-80p xl:w-80p md:w-80p md:justify-start text-16 md:text-18 leading-31">
                <a href={'tel:+6531594885'} className={'block font-b300'}>
                  +6531594885 - <span className={'font-medium'}>Singapore</span>
                </a>
                <span className={`w-26 h-26 inline-block align-middle bg-center bg-no-repeat ml-10 ${styles.sg}`} />
              </p>
              <p className="flex justify-between w-full font-medium lg:w-80p xl:w-80p md:w-80p md:justify-start text-16 md:text-18 leading-31">
                <a href={'tel:+19295909255'} className={'block font-b300'}>
                  +19295909255 - <span className={'font-medium'}>US</span>
                </a>
                <span className={`w-26 h-26 inline-block align-middle bg-center bg-no-repeat ml-10 ${styles.us}`} />
              </p>
            </div>
          </div>
          <div className={`w-full md:w-half-auto text-left mt-20 md:mt-32`}>
            <div>
              <p className="uppercase text-purple font-bolder text-16 md:text-18 leading-20 ">Our Addresses</p>
              <p className="mt-5 text-16 md:text-18 leading-20 font-b300 md:mt-10">Anastas Mikoyan 2/2</p>
              <p className="mt-5 text-16 md:text-18 leading-20 font-b300 md:mt-7">Yerevan 0090, Armenia</p>
            </div>
            <div>
              <p className="mt-20 uppercase text-purple font-bolder text-16 md:text-18 leading-20 md:mt-24">Our Contacts</p>
              <a className="block mt-5 text-16 md:text-18 leading-20 font-b300 md:mt-10 hover:underline" href="mailto:info@weprodigi.com">
                info@weprodigi.com
              </a>
              <a
                href={'tel:' + getPhone()}
                id={'call-click'}
                className="block pb-20 mt-5 text-16 md:text-18 leading-20 font-b300 md:mt-7 md:pb-0 hover:underline"
              >
                <Phone continent={continent} country={country} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${sectionClassesReverse} ${styles.socialBlock} text-center flex justify-center flex-col items-center container-fluid p-0 h-234`}
      >
        <p className="text-30 text-title mb-15">Another Way?</p>
        <p className="font-normal text-18 leading-20 mb-15 text-purple">Communicate with</p>
        <ul className="flex">
          <li>
            <a rel="noopener noreferrer nofollow" aria-label="whatsapp" target="_blank" href="https://api.whatsapp.com/send?phone=37441230330">
              <span className={`${styles.whatsapp} w-35 sm:w-26 h-25 p-20 cursor-pointer inline-block bg-center bg-no-repeat`} />
            </a>
          </li>
          <li>
            <a rel="noopener noreferrer nofollow" aria-label="viber" target="_blank" href="viber://chat?number=%2B37441230330">
              <span className={`${styles.viber} w-35 sm:w-26 h-25 p-20 cursor-pointer inline-block bg-center bg-no-repeat`} />
            </a>
          </li>
          <li>
            <a rel="noopener noreferrer nofollow" aria-label="telegram" target="_blank" href="https://t.me/prodigidigitalagency">
              <span className={`${styles.telegram} w-35  sm:w-26  h-25 p-20 cursor-pointer inline-block bg-center bg-no-repeat`} />
            </a>
          </li>
          <li>
            <a rel="noopener noreferrer nofollow" aria-label="messenger" target="_blank" href="https://m.me/weprodigi">
              <span className={`${styles.messenger} w-35 sm:w-26  h-25 p-20 cursor-pointer inline-block bg-center bg-no-repeat`} />
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ContactUs;
